<template>
  <div class="container">
    <div class="d-flex flex-column flex-fill h-100 bg--white border-radius m-t-25 m-b-25 p-30">
      <ak-form
          :bundle="bundle"
          :definition="definition"
          :objectId="objectId"
          :relationString="relationString"
          @save="goToGrid"
          :key="bundle + definition + objectId"
      >
      </ak-form>
    </div>
  </div>

</template>

<script>

export default {
    name: 'FormPageFull',
    computed: {
        bundle() {
            return this.$route.params.bundle;
        },
        definition() {
            return this.$route.params.definition;
        },
        objectId() {
            return this.$route.params.objectId ?
                    this.$route.params.objectId:
                    'new';
        },
        relationString() {
            return this.$route.params.relationString;
        }
    },
    methods: {
        goToGrid(data) {
            this.$router.push({ name: 'grid' , params: {
                    bundle: data.bundleId,
                    gridDefinition: data.definitionId,
                }});
        }
    }
}
</script>
